<template>
  <div>
    <h5 class="title is-5">
      Create Your First Team
    </h5>
    <p class="is-size-6 u-m-b">
      You can name your team anything, but we recommend modeling your teams after your company structure.
    </p>
    <form @submit.prevent="handleSubmitCreateTeam">
      <b-field
        :type="formErrors[createTeamForm.teamName.name] ? 'is-danger' : ''"
        :message="formErrors[createTeamForm.teamName.name] || ''"
      >
        <template slot="label">
          Team Name
          <span class="is-size-7 has-text-grey has-text-weight-normal">
            (Don't worrry you can change this later)
          </span>
        </template>
        <b-input
          v-model="createTeamForm.teamName.value"
          :disabled="isFormSubmissionInProgress"
          placeholder="Ex: The A Team"
          ref="teamNameInput"
        />
      </b-field>
      <b-button
        type="is-primary"
        native-type="submit"
        size="is-large"
        class="is-fullwidth"
        :loading="isFormSubmissionInProgress"
      >
        Create Team
      </b-button>
    </form>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import * as teamHelpers from '@/helpers/teamHelpers';
import * as TeamActions from '@/store/actions/Team.actions';
import * as ValidationService from '@/services/Validation.service';
import { isObjectEmpty } from '@/helpers/dataHelpers';

export default {
  name: 'OnboardingCreateWorkspaceForm',

  data() {
    return {
      createTeamForm: {
        teamName: {
          name: 'Team Name',
          value: '',
          required: true,
        },
      },
      isFormSubmissionInProgress: false,
      formErrors: {},
    };
  },

  computed: {
    ...mapGetters([
      'loggedInUser',
    ]),
    ...mapState({
      activeWorkspaceId: state => state.workspace.activeWorkspaceId,
    }),
    newTeamPayload() {
      return {
        ...teamHelpers.DEFAULT_TEAM,
        teamName: this.createTeamForm.teamName.value,
        teamLeaderId: this.loggedInUser.id,
        workspaceId: this.activeWorkspaceId,
        slackMeetingReminder: false,
        slackGoalNotification: false,
        userIds: [this.loggedInUser.id],
      };
    },
  },

  mounted() {
    this.setInitialFormState();
  },

  methods: {
    ...mapActions({
      createTeam: TeamActions.CREATE_TEAM,
    }),
    setInitialFormState() {
      this.$refs.teamNameInput.$el.querySelector('input').focus();
    },
    handleSubmitCreateTeam() {
      this.formErrors = ValidationService.runFormValidation({ ...this.createTeamForm });
      if (!isObjectEmpty(this.formErrors)) return;

      this.isFormSubmissionInProgress = true;
      this.createTeam({ newTeam: this.newTeamPayload, workspaceId: this.activeWorkspaceId })
        .then((createdTeamRef) => {
          this.$emit('submitSuccess', createdTeamRef.id);
          this.isFormSubmissionInProgress = false;
        })
        .catch(() => {
          this.isFormSubmissionInProgress = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
